var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radar-chart',{attrs:{"data":_vm.data,"options":_vm.option,"height":200}})}
var staticRenderFns = []

export { render, staticRenderFns }